import React from 'react';
import ReCaptcha from './ReCaptcha';

export default function ReCaptchaWrapper() {
  const handleReCaptcha = (token) => {
    console.log('reCAPTCHA token:', token);
  };

  return <ReCaptcha onVerify={handleReCaptcha} />;
}
